export const paymentsState = {
  filters: {
    source: [],
    status: '',
    term: '',
    usedFor: ['all'],
  },
  isCountryUs: false,
  isParamsReviewed: false,
  pagination: {
    currentPage: 1,
    perPage: 25,
  },
  payments: {
    data: {},
    error: {},
    loading: false,
  },
  sortedField: {},
}
